<template>
    <Modal>
        <template #title>{{ modalTitle }}</template>

        <form id="form" @submit.prevent="formSubmit">
            <div v-if="errorForm" class="form-error">
                <p>{{ errorForm }}</p>
            </div>

            <div v-if="displayTrimNameField" class="form-field">
                <label class="form-field-label">
                    Trim name:
                </label>

                <template v-if="isEdit && hasAdminAccess">
                    <input v-if="hasAdminAccess" type="text" v-model="trimName">

                    <small v-if="errorTrimName" class="error-text">{{ errorTrimName }}</small>
                </template>
                <template v-else>{{ trimName }}</template>
            </div>

            <div class="form-field">
                <label class="form-field-label">
                    Description:
                </label>
                <textarea v-model="description"></textarea>
            </div>

            <div v-if="displaySmallTrimField" class="form-field">
                <label class="form-field-label" :class="{disabled: isDuplicate}">
                    Small trim: <input type="checkbox" v-model="isSmallTrim" :disabled="isDuplicate">
                </label>
            </div>
        </form>

        <template #footer>
            <Button class="gray" @click="closeModal">Cancel</Button>

            <Button type="submit" form="form" :loading="sendStatus">{{ btnSubmitTitle }}</Button>
        </template>
    </Modal>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Modal from "../Modal";
    import Button from "../Button";

    export default {
        name: "TrimInfoModal",

        components: {
            Button,
            Modal,
        },

        emits: [
            'formSubmit',
        ],

        props: {
            modalTitle: {
                type: String,
                default: 'Trim info',
            },
            btnSubmitTitle: {
                type: String,
                default: 'Save',
            },
            sendStatus: {
                type: Boolean,
                default: false,
            },
            errors: {
                type: Object,
                default: undefined,
            },

            isCreateNew: {
                type: Boolean,
                default: false,
            },

            isDuplicate: {
                type: Boolean,
                default: false,
            },

            isEdit: {
                type: Boolean,
                default: false,
            },

            trimId: {
                type: Number,
                default: null,
            },

            trimNamePreset: {
                type: String,
                default: '',
            },

            descriptionPreset: {
                type: String,
                default: '',
            },

            isSmallTrimPreset: {
                type: Boolean,
                default: false,
            },

        },

        data() {
            return {
                trimName: '',
                description: '',
                isSmallTrim: false,
            }
        },

        computed: {
            ...mapGetters('authentication', [
                'hasAdminAccess',
            ]),

            displayTrimNameField() {
                return !this.isCreateNew && !this.isDuplicate;
            },

            displaySmallTrimField() {
                return this.isCreateNew || this.isDuplicate;
            },

            errorForm() {
                return this.errors?.form;
            },

            errorTrimName() {
                return this.errors?.trimName;
            },

            trimData() {
                let trimId = this.trimId;
                let trimName = this.trimName.trim();
                let description = this.description.trim();
                let isSmallTrim = this.isSmallTrim;

                let data = {
                    trimId,
                    trimName,
                    description,
                    isSmallTrim,
                };

                return data;
            },

        },

        methods: {
            closeModal() {
                this.$emit('closeModal');
            },

            async formSubmit() {

                this.$emit('formSubmit', this.trimData);
            },

            initPresets() {
                this.trimName = this.trimNamePreset;
                this.description = this.descriptionPreset;
                this.isSmallTrim = this.isSmallTrimPreset;
            },

        },

        beforeMount() {
            this.initPresets();
        },

    }
</script>

<style >

</style>